import React from "react";

export default function TermsPage() {
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "140px auto",
        padding: "2rem 1rem",
      }}
    >
      <h1
        style={{
          color: "black",
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "1.5rem",
        }}
      >
        Terms and Conditions
      </h1>

      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <section>
          <p style={{ color: "#374151", marginBottom: "1rem" }}>
            Welcome to Sabina AI. These Terms and Conditions ("Terms") govern
            your access to and use of our website, services, and products
            (collectively, the "Services"). By accessing or using Sabina AI, you
            agree to be bound by these Terms.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            1. Use of Services
          </h2>
          <p style={{ color: "#374151" }}>
            Sabina AI provides CRM and recruitment solutions, including but not
            limited to job application management, candidate tracking, and
            AI-enhanced applicant evaluation tools. You agree to use the
            Services only for lawful purposes and in accordance with these
            Terms.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            2. User Accounts
          </h2>
          <p style={{ color: "#374151" }}>
            To access certain features, you may be required to create an account
            and provide accurate, complete information. You are responsible for
            maintaining the confidentiality of your account credentials and for
            all activities under your account.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            3. Intellectual Property
          </h2>
          <p style={{ color: "#374151" }}>
            All content, trademarks, logos, and intellectual property displayed
            on Sabina AI are owned by Sabina AI or its licensors. You may not
            use any content from Sabina AI without prior written permission,
            except as allowed under applicable law.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            4. AI Processing of Job Applications
          </h2>
          <p style={{ color: "#374151" }}>
            Sabina AI uses artificial intelligence (AI) tools to assist with the
            processing and evaluation of job applications. Specifically:
          </p>
          <ul
            style={{
              color: "#374151",
              marginLeft: "1.5rem",
              marginTop: "0.5rem",
            }}
          >
            <li>
              We parse CVs and other application materials to extract relevant
              data.
            </li>
            <li>
              We use AI to generate a preliminary assessment or "score" to
              assist recruiters in evaluating candidates.
            </li>
            <li>
              Transparency & Fairness: The AI-generated scores are intended to
              support, not replace, human judgment. Final hiring decisions are
              made by human recruiters. We continuously monitor our AI systems
              to promote fairness and reduce bias.
            </li>
            <li>
              Data Privacy: By submitting a job application through Sabina AI,
              you acknowledge and consent to the processing of your personal
              data using AI tools as described. We handle your data in
              compliance with applicable data protection laws.
            </li>
          </ul>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            5. Privacy Policy
          </h2>
          <p style={{ color: "#374151" }}>
            Your use of Sabina AI is also governed by our Privacy Policy, which
            outlines how we collect, use, and protect your personal information.
            Please review it carefully.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            6. Restrictions
          </h2>
          <p style={{ color: "#374151" }}>You agree not to:</p>
          <ul
            style={{
              color: "#374151",
              marginLeft: "1.5rem",
              marginTop: "0.5rem",
            }}
          >
            <li>Violate any applicable laws or regulations.</li>
            <li>Use the Services for unauthorized or unlawful purposes.</li>
            <li>
              Attempt to interfere with or compromise the system integrity or
              security of Sabina AI.
            </li>
          </ul>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            7. Disclaimers and Limitation of Liability
          </h2>
          <p style={{ color: "#374151" }}>
            Sabina AI provides its Services "as is" without warranties of any
            kind, express or implied. We do not guarantee the accuracy or
            completeness of any content or service. To the maximum extent
            permitted by law, Sabina AI disclaims all liability for any damages
            arising out of your use of the Services.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            8. Modifications
          </h2>
          <p style={{ color: "#374151" }}>
            We reserve the right to modify these Terms at any time. Changes will
            be posted on this page, and your continued use of the Services after
            such changes constitutes acceptance of the new Terms.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            9. Governing Law
          </h2>
          <p style={{ color: "#374151" }}>
            These Terms are governed by and construed in accordance with
            applicable laws.
          </p>
        </section>

        <section>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
              color: "black",
            }}
          >
            10. Contact Us
          </h2>
          <p style={{ color: "#374151" }}>
            For questions about these Terms, please contact us at:
          </p>
          <p style={{ color: "#374151", marginTop: "0.5rem" }}>
            Sabina AI Support Team
            <br />
            Email: support@sabinaai.com
          </p>
        </section>

        <section>
          <p style={{ color: "#374151", marginTop: "2rem" }}>
            By using Sabina AI, you acknowledge that you have read, understood,
            and agree to be bound by these Terms and Conditions.
          </p>
        </section>
      </div>
    </div>
  );
}
